import { HttpErrorResponse } from "@angular/common/http";
import { IUserAddMessagesHelper } from "./user-add-messages.helper";

export interface IUserAddSearchMessagesHelper {
  title: string;
  description: string;
}

export class UserAddSearchMessagesHelper {
  private readonly DEFAULT_ERROR: IUserAddSearchMessagesHelper = {
    title: "Não foi possível buscar o usuário.",
    description:
      "Estamos trabalhando para resolver esse problema. Por favor, tente novamente mais tarde e, se o erro persistir, entre em contato com a nossa equipe de atendimento.",
  };

  public status = 0;
  public errorObj: { code: string; description: string };

  public descriptions: any = {
    404: {
      default: {
        ...this.DEFAULT_ERROR,
      },
      "27": {
        title: "Usuário não encontrado.",
        description:
          "Por favor, pesquise um novo usuário para espelhar os acessos.",
      },
    },
    422: {
      default: {
        ...this.DEFAULT_ERROR,
      },
      "28": {
        title: "Esse usuário não pode ser espelhado.",
        description:
          "É necessário esperar 24 horas para espelhar um usuário recém-criado.",
      },
      "29": {
        title: "Esse usuário não pode ser espelhado.",
        description:
          "Por favor, pesquise um novo usuário para espelhar os acessos.",
      },
      "30": {
        title: "Não é possível espelhar os acessos de um usuário bloqueado.",
        description:
          "Por favor, pesquise um novo usuário para espelhar os acessos.",
      },
      "37": {
        title: "Não foi possível criar o usuário.",
        description:
          "Você atingiu a quantidade máxima de usuários desse contrato, entre em contato com a nossa equipe de atendimento.",
      },
      "38": {
        title: "Não foi possível espelhar os acessos de um usuário pendente.",
        description:
          "Usuários com pendência de cadastro ou que nunca acessaram o Menu de Produtos não podem ser usados como espelho. Por favor, pesquise um novo usuário para espelhar os acessos.", // NOSONAR
      },
    },
  };

  constructor(error: HttpErrorResponse) {
    this.status = error.status;
    this.errorObj = error.error && error?.error[0];
  }

  get error(): IUserAddMessagesHelper {
    const descriptionObj = this.descriptions[this.status];
    const code = this.errorObj?.code;
    return descriptionObj && descriptionObj[code]
      ? descriptionObj[code]
      : this.DEFAULT_ERROR;
  }
}
